// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";


export default createVuetify({
  components,
  directives,
  ssr: true,
  defaults: {
    VBtn: {
      style: [{ textTransform: "none" }],
    },
    VCard: {
      style: [{ borderColor: "#ced4da" }],
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#5A1A60",
          secondary: "#C986BE",
          error: "#B00020",
          info: "#F44336",
          success: "#4CAF50",
          warning: "#FB8C00",
          background: "#F3E5F5",
          surface: "#FFFFFF",

        },
      },
      dark: {
        primary: "#005ba8",
        secondary: "#00a3e7",
        error: "#B00020",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
        background: "#f7f7f7",
        surface: "#FFFFFF",
      },
      icons: {
        defaultSet: "mdi", // This is already the default value - only for display purposes
      },
    },
  },
})
